import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

function ProfileDropdown() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const goToTab = (tab) => {
    navigate('/merchant-profile/', { state: { tab } })
    setOpen(false)
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="user-avatar"
        onClick={() => setOpen(!open)}
        title="View profile"
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
      >
        <span role="img" aria-label="user">🧑‍💼</span>
      </button>

      {open && (
        <div className="profile-dropdown-menu">
          <div className="profile-dropdown-item" onClick={() => goToTab('profile')}>
            {t('profile.businessInformation')}
          </div>
          <div className="profile-dropdown-item" onClick={() => goToTab('language')}>
            {t('profile.languagePreference')}
          </div>
          <div className="profile-dropdown-item" onClick={() => goToTab('cookie-settings')}>
            {t('profile.cookieSettings')}
          </div>
          <div className="profile-dropdown-item" onClick={() => goToTab('delete-account')}>
            {t('profile.deleteAccount')}
          </div>
        </div>
      )}
    </div>
  )
}

export default ProfileDropdown
